import apiClient from "@/utils/httpClient";
import type {
  BillWorkflowStatusDto,
  CreateBillWorkflowStatusRequest,
  UpdateBillWorkflowStatusRequest,
} from "@blinkbooks/types";

export const listBillWorkflowStatuses = async (): Promise<BillWorkflowStatusDto[]> => {
  return apiClient.get<BillWorkflowStatusDto[]>("/bill-workflow-statuses");
};

export const createBillWorkflowStatus = async (
  data: CreateBillWorkflowStatusRequest
): Promise<BillWorkflowStatusDto> => {
  return apiClient.post<BillWorkflowStatusDto>("/bill-workflow-statuses", data);
};

export const updateBillWorkflowStatus = async (
  id: string,
  data: UpdateBillWorkflowStatusRequest
): Promise<BillWorkflowStatusDto> => {
  return apiClient.patch<BillWorkflowStatusDto>(`/bill-workflow-statuses/${id}`, data);
};

export const deleteBillWorkflowStatus = async (id: string): Promise<void> => {
  await apiClient.delete(`/bill-workflow-statuses/${id}`);
};

export const setBillStatus = async (billId: string, workflowStatusId: string | null): Promise<void> => {
  await apiClient.patch(`/expenses-payable/bills/${billId}/workflow-status`, { workflowStatusId });
};
